import { useState, useEffect } from 'react';

/**
 * Custom hook to handle authentication state
 * Consolidates authentication-related logic
 */
export const useAuth = () => {
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalProfile, setOpenModalProfile] = useState(false);

  // Initialize login state from localStorage
  useEffect(() => {
    const storedLoginStatus = localStorage.getItem('isLoggedIn');
    if (storedLoginStatus) {
      setLoggedIn(true);
    }
  }, []);

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleOpenProfile = () => {
    setOpenModalProfile(true);
  };

  const handleCloseProfile = () => {
    setOpenModalProfile(false);
  };

  const handleLoginSuccess = () => {
    setLoggedIn(true);
    setOpenModal(false);
    localStorage.setItem('isLoggedIn', 'true');
  };

  const handleLogout = () => {
    setLoggedIn(false);
    localStorage.removeItem('isLoggedIn');
  };

  return {
    isLoggedIn,
    openModal,
    openModalProfile,
    setOpenModalProfile,
    handleOpen,
    handleClose,
    handleOpenProfile,
    handleCloseProfile,
    handleLoginSuccess,
    handleLogout
  };
};

